import React, { useState, useEffect } from "react";
import { crudData } from "../../services/apiService";
import ProductWrap from "../../Mescomposants/Product/ProductWrap";
import Pagination from "../../Mescomposants/Pagination/Pagination";
import { generatePageNumbers } from "../../services/lib";

const Nouveautes = ({ param, defaultImage }) => {
    const mode = JSON.parse(localStorage.getItem("appMode"));
    const apiEndpointe = JSON.parse(localStorage.getItem("apiEndpointe"));

    const [products, setProducts] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [totalPage, setTotalPage] = useState(0);
    const [pageNumbers, setPageNumbers] = useState([]);
    const limit = 10;

    /*const fetchNouveautes = (currentPage) => {
        setIsLoading(true);
        const params = {
            mode: mode.listLastestItemsMode,
            LIMIT: limit.toString(),
            PAGE: currentPage.toString(),
        };
        crudData(params, apiEndpointe.StockManagerEndPoint)
            .then((response) => {
                setIsLoading(false);
                if (response && response.status === 200) {
                    setProducts(response.data.data || []);
                    setTotalPage(Math.ceil(response.data.total / limit));
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error("Erreur:", error);
            });
    };*/

    const fetchNouveautes = (currentPage) => {
        setIsLoading(true);
        const params = {
            mode: mode.listLastestItemsMode,
            LIMIT: limit.toString(),
            PAGE: currentPage.toString(),
        };
        crudData(params, apiEndpointe.StockManagerEndPoint)
            .then((response) => {
                setIsLoading(false);
                if (response && response.status === 200) {
                    setProducts(response.data.data || []);
                    setTotalPage(Math.ceil((response.data.total || 0) / limit));
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error("Erreur:", error);
            });
    };

    useEffect(() => {
        fetchNouveautes(page);
    }, [page]);

    useEffect(() => {
        setPageNumbers(generatePageNumbers(totalPage, page));
    }, [page, totalPage]);

    const goToPage = (newPage) => {
        setPage(newPage);
        window.scrollTo(0, 0);
    };

    return (
        <div className={param.userData ? "bgUserConnected" : ""}>
            <div className="page-wrapper">
                <main className="main mb-0 pb-1">
                    <div className="page-header">
                        <div className="container">
                            <h1 className="page-title mb-0">Nouveautés</h1>
                        </div>
                    </div>
                    <div className="page-content">
                        <div className="container pt-5">

                            {isLoading ? (
                                <div className="d-flex justify-content-center p-5">
                                    <p>Chargement des nouveautés...</p>
                                </div>
                            ) : products.length > 0 ? (
                                <>
                                    <div className="product-wrapper row cols-xl-4 cols-md-3 cols-sm-2 cols-2">
                                        {products.map((product) => (
                                            <ProductWrap
                                                key={product.ArtID}
                                                product={product}
                                                defaultImage={defaultImage}
                                                urlBaseImage={param.urlBaseImage}
                                                userData={param.userData}
                                                col_css="d-flex justify-content-center"
                                            />
                                        ))}
                                    </div>
                                    <Pagination
                                        currentPage={page}
                                        totalPages={totalPage}
                                        onPageChange={goToPage}
                                        pageNumbers={pageNumbers}
                                    />
                                </>
                            ) : (
                                <div className="text-center p-5">
                                    <img
                                        src="images/undraw_no-data.svg"
                                        alt="Pas de nouveautés"
                                        style={{ 
                                            maxWidth: "300px", 
                                            marginBottom: "20px",
                                            // backgroundColor: "#f8fafd"
                                        }}
                                    />
                                    <p className="text-muted" style={{fontWeight: "bold", fontSize: "25px"}}>
                                        Oups… aucune nouveauté pour le moment.
                                    </p>
                                </div>

                                // <div className="text-center p-5">
                                //     <p>Aucune nouveauté disponible.</p>
                                // </div>
                                
                                
                            )}

                        </div>
                    </div>
                </main>
            </div>
        </div>
    );
};

export default Nouveautes;